/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum AccessTokenPermission {
    Nothing = 0,
    Read = 1,
    Write = 2,
    All = 3
}

export function AccessTokenPermissionFromJSON(json: any): AccessTokenPermission {
    return AccessTokenPermissionFromJSONTyped(json, false);
}

export function AccessTokenPermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessTokenPermission {
    return json as AccessTokenPermission;
}

export function AccessTokenPermissionToJSON(value?: AccessTokenPermission | null): any {
    return value as any;
}

